import * as React from "react";
import Axios from "axios";
import moment from "moment";
import { NavLink } from "react-router-dom";
import {
  FormControlLabel,
  Grid,
  Button,
  IconButton,
  Box,
  Paper,
  Card,
  CardContent,
  CardHeader,
  TextField,
  InputAdornment,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { blue, red } from "@mui/material/colors";

import Layout from "../Layout/Layout";
import { seesionCheck, textStatus } from "../Layout/function";

import "./CatalogTable.css";

async function getCallData() {
  try {
    let result = await Axios.get(
      process.env.REACT_APP_BACKEND_DOMAIN_API + "/cms_catalogs/all_lists",
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
        },
      }
    );
    return result.data.data;
  } catch (error) {
    console.log(`bigc-online-catalogs: ${error}`);
  }
}

const MatchEdit = ({ index }) => {
  return (
    <FormControlLabel
      control={
        <NavLink to={`/cms-catalogs/edit/${index}`}>
          <EditIcon style={{ color: blue[500] }} />
        </NavLink>
      }
    />
  );
};

// Accepts a name, a friendly url, or a full public link such as
// https://linebc.bigc.co.th/catalog/<friendly_url>?x=y and returns the
// normalised text to match against.
const normalizeSearch = (value) => {
  let text = `${value || ""}`.trim();
  if (!text) return "";
  const match = text.match(/\/catalog\/([^/?#]+)/i);
  if (match) text = match[1];
  try {
    text = decodeURIComponent(text);
  } catch (e) {
    // keep raw text when it is not valid URI encoding
  }
  return text.toLowerCase();
};

const columns = [
  { field: "id", headerName: "ID", width: 50 },
  {
    field: "actions",
    headerName: "#",
    sortable: false,
    filterable: false,
    hideable: false,
    width: 50,
    disableClickEventBubbling: false,
    headerAlign: "center",
    renderCell: (params) => {
      return (
        <div className="ml-1 d-flex justify-content-between align-items-center dg-edit-icon">
          <MatchEdit index={params.row.id} />
        </div>
      );
    },
  },
  {
    field: "hotspot",
    headerName: "Hotspot",
    sortable: false,
    filterable: false,
    hideable: false,
    width: 180,
    headerAlign: "center",
    renderCell: (params) => (
      <NavLink to={`/cms-catalogs/hotspot/${params.row.id}`}>
        <Button
          size="small"
          variant="contained"
          fullWidth
          sx={{ minWidth: 0, px: 2, py: 0.5, mx: 1 }}
        >
          Add Hotspot
        </Button>
      </NavLink>
    ),
  },
  { field: "name", headerName: "Name", width: 300 },
  { field: "friendly_url", headerName: "Friendly URL", width: 280 },
  { field: "effective_start_date", headerName: "Start", width: 200 },
  { field: "effective_end_date", headerName: "End", width: 200 },
  { field: "display_order", headerName: "Order", width: 100 },
  { field: "status", headerName: "Status", width: 130 },
];

export default function DataTable() {
  const [coupon, setCoupon] = React.useState([]);
  const [search, setSearch] = React.useState("");

  React.useEffect(async () => {
    await seesionCheck();
    const getCoupon = await getCallData();
    setCoupon(getCoupon);
  }, []);

  coupon.map((val) => {
    val.status = textStatus(val.status);

    if (val.display_order === null) {
      val.display_order = "N/A";
    }
    /*
    //val.id = val._id;
    if (val.effective_start_date) {
      val.effective_start_date = moment(val.effective_start_date).format('YYYY-MM-DD HH:mm:ss');
    }
    if (val.effective_end_date) {
      val.effective_end_date = moment(val.effective_end_date).format('YYYY-MM-DD HH:mm:ss');
    }*/
  });
  const keyword = normalizeSearch(search);
  const filteredRows = keyword
    ? coupon.filter((val) =>
        [val.id, val.name, val.friendly_url].some((field) =>
          `${field ?? ""}`.toLowerCase().includes(keyword)
        )
      )
    : coupon;

  return (
    <Layout>
      <Paper sx={{ height: 800, width: "100%", mb: 10 }}>
        <Card>
          <CardHeader title="Catalogs" />
        </Card>
        <Box
          sx={{
            pt: 3,
            mb: 2,
            px: 2,
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            alignItems: "center",
          }}
        >
          <NavLink to={`/cms-catalogs/add`}>
            <Button color="primary" variant="outlined">
              <AddIcon style={{ color: blue[500] }} /> Add New Coupon
            </Button>
          </NavLink>
          <TextField
            size="small"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="ค้นหา ชื่อ / Friendly URL / วาง URL แคตตาล็อก"
            sx={{ flex: 1, minWidth: 280, maxWidth: 520 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <DataGrid
          sx={{ height: 650 }}
          rows={filteredRows}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
        />
      </Paper>
    </Layout>
  );
}
